import { RootState } from "src/shared/types/src";

export const getNotificationsLoading = (state: RootState) => state?.notifications?.isLoading || false;

export const getNotificationsPaginatedLoading = (state: RootState) => state?.notifications?.paginatedLoading || false;

export const getNotificationsList = (state: RootState) => state?.notifications?.notificationList || [];

export const getNotificationsCurrentPage = (state: RootState) => state?.notifications?.pagination?.currentPage || 1;

export const getNotificationsLastPage = (state: RootState) => state?.notifications?.pagination?.lastPage || 1;

export const getNotificationsUnreadCount = (state: RootState) => state?.notifications?.unReadCount || 0;
